import React from "react";
import {
  Link,
} from "react-router-dom";
import './Homepage.css';

const publicUrl = process.env.PUBLIC_URL

const offsetLeft = function() {
  const maxOffsetLeft = 200;

  return Math.floor(Math.random() * maxOffsetLeft);
};

const offsetTop = function() {
  const maxOffsetTop  = 100;

  return Math.floor(Math.random() * maxOffsetTop);
};

const projects = [
  [
    {
      id: "Astra-coloured-diary",
      previewUrl: `${publicUrl}/images/Astra-coloured-diary/front.jpg`,
      offsetLeft: offsetLeft(),
      offsetTop: offsetTop(),
    },
    {
      id: "Astra-paper-stars",
      previewUrl: `${publicUrl}/images/Astra-paper-stars/front.jpg`,
      offsetLeft: offsetLeft(),
      offsetTop: offsetTop(),
    },
  ],
  [
    {
      id: "Astra-sketches",
      previewUrl: `${publicUrl}/images/Astra-sketches/front.jpg`,
      offsetLeft: offsetLeft(),
      offsetTop: offsetTop(),
    },
    {
      id: "Astra-blueprint",
      previewUrl: `${publicUrl}/images/Astra-coloured-diary/front-blueprint.jpg`,
      offsetLeft: offsetLeft(),
      offsetTop: offsetTop(),
    },
  ]
];

const styleForProject = (project) => ({
  left: `${project.offsetLeft}px`,
  top: `${project.offsetTop}px`,
  width: '50%',
  position: 'relative',
})

const Projects = () => {
  return (
    <div className="homepage">
      {projects.map((row, index) => {
        return (
          <div key={index} className={`row row-${index}`}>
            {row.map((project) => {
              return (
                <div key={project.id} className={`homepage-project col-md-6 col-sm-6 col-xs-9`} style={styleForProject(project)}>
                  <Link to={`/project/${project.id}`}><img className="preview" src={project.previewUrl} alt={project.id}></img></Link>
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

export default Projects
